import { createColumnHelper } from '@tanstack/react-table';
import { SortableHeadCell, TextCell } from 'components/tables/cells';
import { TextColumnProps } from 'components/tables/columnTypes';
import { Company } from 'domain/company/Company';
import { toDefaultDateFormatOrNotAvailable } from 'utils/dateUtils';

const columnHelper = createColumnHelper<Company>();

export const companyTableColumns = {
	name: (overrideProps?: TextColumnProps<Company>) =>
		columnHelper.accessor((row) => row.name, {
			id: 'name',
			enableSorting: true,
			size: 100,
			header: ({ header }) => (
				<SortableHeadCell
					text="Name"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	created: (overrideProps?: TextColumnProps<Company>) =>
		columnHelper.accessor((row) => row.created, {
			id: 'created',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Created"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={toDefaultDateFormatOrNotAvailable(info.getValue())}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	country: (overrideProps?: TextColumnProps<Company>) =>
		columnHelper.accessor((row) => row.country.name, {
			id: 'country',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Country"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	youniumAccountNumber: (overrideProps?: TextColumnProps<Company>) =>
		columnHelper.accessor((row) => row.youniumAccountNumber, {
			id: 'youniumAccountNumber',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Younium Account Number"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	isCustomer: (overrideProps?: TextColumnProps<Company>) =>
		columnHelper.accessor((row) => (row.isCustomer ? 'Yes' : 'No'), {
			id: 'isCustomer',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Is customer"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
};
